import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const ActionButton = ({ placement = 'top', title, icon, tooltip, ...rest }) => {
  return (
    <>
      {tooltip && (
        <OverlayTrigger
          placement={placement}
          overlay={<Tooltip style={{ position: 'fixed' }}>{title}</Tooltip>}
        >
          <Button {...rest}>
            <FontAwesomeIcon icon={icon} />
          </Button>
        </OverlayTrigger>
      )}
      {!tooltip && (
        <Button {...rest}>
          <FontAwesomeIcon icon={icon} />
        </Button>
      )}
    </>
  );
};

ActionButton.propTypes = {
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  tooltip: PropTypes.bool
};

export default ActionButton;
